import { Component, Input } from '@angular/core';

import {
  faRobot,
  faSyncAlt,
  faChartLine,
  faComments,
  faNetworkWired,
  faShareAlt,
  faBullseye,
  faChartBar,
  faLayerGroup,
  faHandHoldingDroplet,
  faHouseFloodWaterCircleArrowRight,
  faTarpDroplet,
  faArrowUpFromWaterPump,
  faBridgeWater,
  faTruckDroplet,
  faAnchor,
  faCreditCard,
  faHandshake,
  faPrescriptionBottleMedical,
  faShip,
  faStethoscope,
  faUserPlus,
  faUserShield,
  faDumbbell,
  faHospital,
  faHospitalSymbol,
  faMoneyBillWave,
  faMugHot,
  faUtensils,
} from '@fortawesome/free-solid-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  faChartSimple,
  faCode,
  faSquarePollVertical,
  faPalette,
  faBusinessTime,
  faMagnifyingGlassChart,
  faGlassWaterDroplet,
  faHouseFloodWater,
} from '@fortawesome/free-solid-svg-icons';
import { faConnectdevelop } from '@fortawesome/free-brands-svg-icons';

@Component({
  selector: 'app-grid-service-cards',
  templateUrl: './grid-service-cards.component.html',
  styleUrls: ['./grid-service-cards.component.css'],
})
export class GridServiceCardsComponent {
  @Input() data: any;
  @Input() language!: string;

  icons: { [key: string]: IconProp } = {
    faChartSimple: faChartSimple,
    faCode: faCode,
    faSquarePollVertical: faSquarePollVertical,
    faBusinessTime: faBusinessTime,
    faPalette: faPalette,
    faMagnifyingGlassChart: faMagnifyingGlassChart,
    faConnectdevelop: faConnectdevelop,
    faRobot: faRobot,
    faSyncAlt: faSyncAlt,
    faChartLine: faChartLine,
    faComments: faComments,
    faNetworkWired: faNetworkWired,
    faShareAlt: faShareAlt,
    faBullseye: faBullseye,
    faChartBar: faChartBar,
    faLayerGroup: faLayerGroup,
    faHandHoldingDroplet: faHandHoldingDroplet,
    faTarpDroplet: faTarpDroplet,
    faHouseFloodWaterCircleArrowRight: faHouseFloodWaterCircleArrowRight,
    faHouseFloodWater: faHouseFloodWater,
    faGlassWaterDroplet: faGlassWaterDroplet,
    faArrowUpFromWaterPump: faArrowUpFromWaterPump,
    faBridgeWater: faBridgeWater,
    faTruckDroplet: faTruckDroplet,

    faAnchor: faAnchor,
    faStethoscope: faStethoscope,
    faCreditCard: faCreditCard,
    faPrescriptionBottleMedical: faPrescriptionBottleMedical,
    faUserShield: faUserShield,
    faShip: faShip,
    faHandshake: faHandshake,
    faUserPlus: faUserPlus,

    faHospitalSymbol: faHospitalSymbol,
    faHospital: faHospital,
    faUtensils: faUtensils,
    faDumbbell: faDumbbell,
    faMugHot: faMugHot,
    faMoneyBillWave: faMoneyBillWave,
  };

  constructor() {}
  ngOnInit() {
    console.log(this.data);
    console.log(this.data);
  }
  getLink(service: any) {
    return (
      '/' +
      this.language +
      '/details/service-page/' +
      this.data.fileName +
      '/' +
      service.title.replace(/\s+/g, '-').toLowerCase()
    );
  }
}
